import { Location, PopStateEvent } from '@angular/common';
import { Component, HostListener, OnInit, ViewChild } from '@angular/core';
import { NavigationEnd, NavigationError, NavigationStart, Router } from '@angular/router';
import { NavbarComponent } from './shared/navbar/navbar.component';

import { DEFAULT_INTERRUPTSOURCES, Idle } from '@ng-idle/core';
import { Keepalive } from '@ng-idle/keepalive';

let lastScrollTop = 0;
const delta = 5;
const navbarHeight = 0;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  idleState = 'Not started.';
  timedOut = false;
  lastPing?: Date;
  title = 'angular-idle-timeout';
  private lastPoppedUrl?: string;
  private yScrollStack: number[] = [];
  url: string = '';
  @ViewChild(NavbarComponent, { static: false }) navbar!: NavbarComponent;
  @ViewChild('childModal', { static: false }) childModal: any;

  resolved(captchaResponse: string) {
    console.log(`Resolved captcha with response: ${captchaResponse}`);
  }

  constructor(private router: Router, public location: Location, private idle: Idle, keepalive: Keepalive) {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        if ((<any>window).ga) {
          (<any>window).ga('set', 'page', event.urlAfterRedirects);
          (<any>window).ga('send', 'pageview');
        } else {
          console.warn('Google Analytics (ga) object not found. Tracking skipped.');
        }
      }

      if (event instanceof NavigationError) {
        console.error('Navigation Error:', event);
      }
    });

    try {
      // sets an idle timeout of 300 seconds (5 minutes)
      idle.setIdle(300);
      // sets a timeout period of 300 seconds (5 minutes)
      idle.setTimeout(300);
      // sets the default interrupts
      idle.setInterrupts(DEFAULT_INTERRUPTSOURCES);

      idle.onIdleEnd.subscribe(() => {
        this.idleState = 'No longer idle.';
        this.reset();
      });

      idle.onTimeout.subscribe(() => {
        this.idleState = 'Timed out!';
        this.timedOut = true;
        console.log('Session timed out due to inactivity');
        localStorage.clear();
        this.router.navigate(['/']);
      });

      idle.onIdleStart.subscribe(() => {
        this.idleState = "You've gone idle!";
        console.log('User idle - clearing session');
        localStorage.clear();
        this.router.navigateByUrl('/logout');
      });

      idle.onTimeoutWarning.subscribe((countdown) => {
        this.idleState = 'You will time out in ' + countdown + ' seconds!';
        console.log(`Timeout warning: ${countdown} seconds remaining`);
      });

      // sets the ping interval to 15 seconds
      keepalive.interval(15);
      keepalive.onPing.subscribe(() => {
        this.lastPing = new Date();
      });

      this.reset();
    } catch (error) {
      console.error('Error setting up idle service:', error);
    }
  }

  @HostListener('window:scroll', ['$event'])
  hasScrolled() {
    let st = window.pageYOffset;
    // Make sure they scroll more than delta
    if (Math.abs(lastScrollTop - st) <= delta) return;

    var navbar = document.getElementsByTagName('nav')[0];

    if (!navbar) return;

    if (st > lastScrollTop && st > navbarHeight) {
      // Scroll Down
      if (navbar.classList.contains('nav-down')) {
        navbar.classList.remove('nav-down');
        navbar.classList.add('nav-up');
      }
    } else {
      // Scroll Up
      if (st + window.innerHeight < document.body.scrollHeight) {
        if (navbar.classList.contains('nav-up')) {
          navbar.classList.remove('nav-up');
          navbar.classList.add('nav-down');
        }
      }
    }

    lastScrollTop = st;
  }

  ngOnInit() {
    if (this.location.path() !== '/sections') {
      this.location.subscribe((ev: PopStateEvent) => {
        this.lastPoppedUrl = ev.url;
      });
      this.router.events.subscribe((event: any) => {
        if (event instanceof NavigationStart) {
          if (event.url != this.lastPoppedUrl) this.yScrollStack.push(window.scrollY);
        } else if (event instanceof NavigationEnd) {
          if (event.url == this.lastPoppedUrl) {
            this.lastPoppedUrl = undefined;
            const scrollY = this.yScrollStack.pop();
            if (scrollY !== undefined) {
              window.scrollTo(0, scrollY);
            }
          } else window.scrollTo(0, 0);
        }
      });
    }

    var ua = window.navigator.userAgent;
    var trident = ua.indexOf('Trident/');
    let version: number | undefined;
    if (trident > 0) {
      // IE 11 => return version number
      var rv = ua.indexOf('rv:');
      version = parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
    }
    if (version) {
      var body = document.getElementsByTagName('body')[0];
      body.classList.add('ie-background');
    }

  }

  removeFooter() {
    var titlee = this.location.prepareExternalUrl(this.location.path());
    titlee = titlee.slice(1);
    if (titlee === 'signup' || titlee === 'nucleoicons') {
      return false;
    } else {
      return true;
    }
  }

  reset() {
    try {
      this.idle.watch();
      this.idleState = 'Started.';
      this.timedOut = false;
    } catch (error) {
      console.error('Error resetting idle timer:', error);
    }
  }
}